import styled from '@emotion/styled'
import { Close } from 'app/components/Common/Close'
import { FlexBox } from 'app/components/Layout/FlexBox'
import React, { memo } from 'react'

export interface Props {
  ID: string
  modalStatus?: boolean
  onClick?: any
}

export const Modal = memo(function Modal({ ID, modalStatus, onClick }: Props) {
  if (!ID) return

  return (
    <Container
      aria-hidden={!modalStatus}
      aria-labelledby="The Fork"
      className={modalStatus ? 'open' : undefined}
      role="dialog"
    >
      <Wrapper>
        <Close className="close" onClick={onClick} variant="simple" />

        <IFrame
          src={`https://widget.thefork.com/${ID}`}
          allow="payment *"
          title="Widget The Fork"
        />
      </Wrapper>
    </Container>
  )
})

const Wrapper = styled(FlexBox)`
  width: 100%;
  max-width: 56.25rem;
  background: ${({ theme }) => theme.colors.variants.neutralLight2};
  cursor: auto;
  margin: auto;
  overflow: hidden;
  opacity: 0;
  position: relative;
  transform: scale(0.8);

  @media (max-width: 767px) {
    display: block;
    padding: 0;
    max-height: -webkit-fill-available;
    overflow-y: auto;
    transform: translateY(100%);
    -webkit-overflow-scrolling: auto;
  }
`

const IFrame = styled.iframe`
  width: 100%;
  height: 100%;
  min-height: 50rem;
  overflow-y: auto;
`

const Container = styled(FlexBox)`
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
  padding: 0 2rem;
  position: fixed;
  top: 0;
  left: 0;
  visibility: hidden;
  z-index: -1;
  transition: 0.2s cubic-bezier(0.25, 1, 0.5, 1);
  &:before {
    content: '';
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.colors.variants.neutralDark1};
    opacity: 0.4;
    position: absolute;
    top: 0;
    left: 0;
  }
  &.open {
    opacity: 1;
    visibility: visible;
    z-index: 10002;

    ${Wrapper} {
      opacity: 1;
      transform: scale(1);
      transition: transform 0.6s cubic-bezier(0.25, 1, 0.5, 1);
    }
  }

  @media (max-width: 767px) {
    padding: 13.519vh 1rem;
  }
`
